<template>
  <section class="section" id="hizmetler">
    <div class="container">
      <p class="eyebrow">{{ t("services.eyebrow") }}</p>
      <h2 class="section-title">{{ t("services.title") }}</h2>
      <p class="section-lead">{{ t("services.lead") }}</p>
      <div class="svc-track">
        <article v-for="(id, index) in serviceIds" :key="id" class="svc-card">
          <span class="code">{{ String(index + 1).padStart(2, "0") }} / {{ String(serviceIds.length).padStart(2, "0") }}</span>
          <h3>{{ t(`services.items.${id}.title`) }}</h3>
          <p>{{ t(`services.items.${id}.text`) }}</p>
          <a class="text-link" href="#iletisim">{{ t("services.talk") }} →</a>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { useI18n } from "vue-i18n";
import { serviceIds } from "@/data/packages";

export default {
  name: "ServicesSection",
  setup() {
    const { t } = useI18n();
    return { t, serviceIds };
  },
};
</script>
